import React, {useState, useEffect} from 'react';
import InputField from '../../reusables/input';
import Dropdown from '../../reusables/dropdown';
import Spinner from '../../reusables/spinner';
import {update_supplier_profile, update_customer_profile} from '../../../redux/actions/adminActions';
import {connect} from 'react-redux';

const ProfileEdit = ({
    selectedCustomer,
    user,
    updateSupplierProfile,
    udpateCustomerProfile,
    customer,
    newUser,
    next,
    accessToken,
    submit,
    close,
    unapproved,
    supplier
}) => {

    const idTypes = ['national_id', 'passport', 'driver_licence']

    const [supplierNewData,
        setNewSupplierData] = useState( !newUser ? {
            photograph: supplier
                ?.photograph,
            business_name: supplier
                ?.business_name,
            manager_name: supplier
                ?.manager_name,
            email_address: supplier
                ?.email_address,
            phone_number: supplier
                ?.phone_number,
            business_address: supplier
                ?.business_address,
            shop_coordinates: supplier
                ?.shop_coordinates,
            sentPhoto: null
        } : null)


    const [customerNewData,
        setCustomerNewData] = useState(!newUser ? {
            display_pic: selectedCustomer?.display_pic,
            first_name: selectedCustomer
                ?.first_name,
            last_name: selectedCustomer
                ?.last_name,
            email: selectedCustomer
                ?.email,
            phone: selectedCustomer
                ?.phone,
            address: selectedCustomer
                ?.address,
            id_type: selectedCustomer
                ?.id_type,
            id_number: selectedCustomer
                ?.id_number,
            sent_display_pic: null
        } : null)

        const [prevData,
            setPrevData] = useState(user || null);

    useEffect(() => {
        if(!newUser){
            if(customer){
                setCustomerNewData(selectedCustomer)
                setPrevData(selectedCustomer)
            }else{
                setNewSupplierData(supplier)
                setPrevData(supplier)
            }
        }
    }, [supplier, newUser, selectedCustomer])


    const [isLoading,
        setIsLoading] = useState(false);

    const handleChange = (e) => {
        if (customer) {
            setCustomerNewData({
                ...customerNewData,
                [e.target.name]: e.target.value
            })
        } else {
            setNewSupplierData({
                ...supplierNewData,
                [e.target.name]: e.target.value
            })
        }
    }

    const handleIDSelect = (id) => {

            let idType = id;
        let currentData = customerNewData;

            let updated = {
                ...currentData,
                id_type: idType
            }

        setCustomerNewData(updated);
    }  
    
    const handleLoading = () => {
        setIsLoading(true);

        setInterval(() => {
            setIsLoading(false)
        }, 4000)
    }

    const handleImageChange = (e) => {
        let reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);

        reader.onloadend = () => {
            if (customer) {
                setCustomerNewData({
                    ...customerNewData,
                    display_pic: reader.result,
                    sent_display_pic: e.target.files[0]
                })

            } else {
                setNewSupplierData({
                    ...supplierNewData,
                    sentPhoto: e.target.files[0],
                    photograph: reader.result
                })

                setPrevData({
                    ...prevData,
                    photograph: reader.result
                })
            }
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        handleLoading();

        if (newUser) {
            submit(customerNewData)
            next();
        } else {

            let customerformdata = new FormData();
            customerformdata.append("display_pic", customerNewData.sent_display_pic || customerNewData.display_pic);
            customerformdata.append("first_name", customerNewData.first_name);
            customerformdata.append("last_name", customerNewData.last_name);
            customerformdata.append("email", customerNewData.email);
            customerformdata.append("phone", customerNewData.phone);
            customerformdata.append("address", customerNewData.address);
            customerformdata.append("id_type", customerNewData.id_type);
            customerformdata.append("id_number", customerNewData.id_number);

            udpateCustomerProfile(prevData.id, customerformdata, unapproved ? 'unapproved' : 'approved' , accessToken, close);
        }
    }

    const handleSupplierSubmit = (e) => {
        e.preventDefault();
        handleLoading();

        if (newUser) {
            submit(supplierNewData);
            next();
        } else {

            let formdata = new FormData();
            formdata.append("photograph", supplierNewData.sentPhoto);
            formdata.append("business_name", supplierNewData.business_name);
            formdata.append("manager_name", supplierNewData.manager_name);
            formdata.append("email_address", supplierNewData.email_address);
            formdata.append("phone_number", supplierNewData.phone_number);
            formdata.append("business_address", supplierNewData.business_address);
            formdata.append("shop_coordinates", supplierNewData.shop_coordinates);

            updateSupplierProfile(prevData.id, formdata, unapproved ? 'unapproved' : 'approved' , accessToken, close);
        }
    }

    return (
        <div className='sectionHeight--mid container'>

            {customer
                ? <form className='py-3 px-2' onSubmit={handleSubmit}>
                        <div className="pb-3 alignOnly isRelative">
                            <div className="profileImg">
                                <img
                                src={ customerNewData
                                    ?.display_pic}
                                    className='w-100'
                                    alt=""/>
                            </div>

                            <div className="mx-2">
                                <input
                                    type="file"
                                    onChange={handleImageChange}
                                    accept="image/png, image/jpg, image/jpeg"
                                    name="display_pic"
                                    id=""/>
                                <span className="textIsGreen sectionText">Upload Image</span>
                            </div>
                        </div>
                        <div className="pb-2">
                            <InputField
                                label="First Name"
                                name='first_name'
                                value={customerNewData
                                ?.first_name}
                                onChange={handleChange}/>
                        </div>

                        <div className="mt-2 mb-2">
                            <InputField
                                label="Last Name"
                                name='last_name'
                                value={customerNewData
                                ?.last_name}
                                onChange={handleChange}/>
                        </div>

                        <div className="mt-2 mb-2">
                            <InputField
                            type='email'
                                label="Email Address"
                                name='email'
                                value={customerNewData
                                ?.email}
                                onChange={handleChange}/>
                        </div>

                        <div className="mt-2 mb-2">
                            <InputField
                                label="Phone Number"
                                name='phone'
                                value={customerNewData
                                ?.phone}
                                onChange={handleChange}/>
                        </div>

                        <div className="mt-2 mb-2">
                            <InputField
                                label="Address"
                                name='address'
                                value={customerNewData
                                ?.address}
                                onChange={handleChange}/>
                        </div>

                        <div className="mt-2 mb-2">
                        <p className="mb-1 textIsBold sectionText--small">ID Type</p>
                        <Dropdown long value={ customerNewData?.id_type || 'Select ID Type' }>
                            { idTypes.map(type => (
                                <div className="isClickable hoverGreen" onClick={ () => handleIDSelect(type) }>
                                    <p className="sectionText px-3 py-2 mb-0">{ type }</p>
                                </div>
                            )) }
                        </Dropdown>
                        </div>

                        <div className="mt-2 mb-2">
                            <InputField
                                label="ID Number"
                                name='id_number'
                                value={customerNewData
                                ?.id_number}
                                onChange={handleChange}/>
                        </div>

                        <div className="mt-4">
                            {isLoading
                                ? <button className="btn__filled textIsBold alignOnly">Please Wait {' '}
                                        <Spinner/>
                                    </button>
                                : newUser
                                    ? <button className="btn__filled textIsBold">Continue</button>
                                    : <button className="btn__filled textIsBold">Save Changes</button>
}
                        </div>
                    </form>
                : <form className='py-3 px-2' onSubmit={handleSupplierSubmit}>
                    <div className="pb-3 alignOnly isRelative">
                        <div className="profileImg">
                            <img
                                src={ prevData
                                ?.photograph}
                                className='w-100'
                                alt=""/>
                        </div>

                        <div className="mx-2">
                            <input
                                type="file"
                                onChange={handleImageChange}
                                accept="image/png, image/jpg, image/jpeg"
                                name="photograph"
                                id=""/>
                            <span className="textIsGreen sectionText">Upload Image</span>
                        </div>
                    </div>
                    <div className="pb-2">
                        <InputField
                            label="Business Name"
                            name='business_name'
                            value={supplierNewData
                            ?.business_name}
                            onChange={handleChange}/>
                    </div>

                    <div className="mt-2 mb-2">
                        <InputField
                            label="Manager’s Name"
                            name='manager_name'
                            value={supplierNewData
                            ?.manager_name}
                            onChange={handleChange}/>
                    </div>

                    <div className="mt-2 mb-2">
                        <InputField
                        type='email'
                            label="Email Address"
                            name='email_address'
                            value={ supplierNewData
                            ?.email_address}
                            onChange={handleChange}/>
                    </div>

                    <div className="mt-2 mb-2">
                        <InputField
                            label="Phone Number"
                            name='phone_number'
                            value={supplierNewData
                            ?.phone_number}
                            onChange={handleChange}/>
                    </div>

                    <div className="mt-2 mb-2">
                        <InputField
                            label="Address"
                            name='business_address'
                            value={supplierNewData
                            ?.business_address}
                            onChange={handleChange}/>
                    </div>

                    <div className="mt-2 mb-2">
                        <InputField
                            label="Store Coordinates"
                            name='shop_coordinates'
                            value={supplierNewData
                            ?.shop_coordinates}
                            onChange={handleChange}/>
                    </div>

                    {newUser && 
                        <>
                        <div className="mt-2 mb-2">
                            <InputField
                                label="Bank Name"
                                name='bank_name'
                                value={ supplierNewData
                                    ?.bank_name }
                                onChange={ handleChange } />
                        </div>


                    <div className="mt-2 mb-2">
                        <InputField
                            label="Account Number"
                                name='account_number'
                            value={supplierNewData
                                ?.account_number}
                            onChange={handleChange}/>
                    </div>

                        <div className="mt-2 mb-2">
                            <InputField
                                label="Account Name"
                                name='account_name'
                                value={ supplierNewData
                                    ?.account_name }
                                onChange={ handleChange } />
                        </div>

                    </>
                    }

                    <div className="mt-4">
                        {isLoading
                            ? <button className="btn__filled textIsBold alignOnly">Please Wait {' '}
                                    <Spinner/>
                                </button>
                            : <button className="btn__filled textIsBold">{newUser ? 'Continue' : 'Save Changes'}</button>
}
                    </div>
                </form>
}

        </div>

    )
}

const mapStateToProps = (state) => ({
    accessToken: state.admin.token,
    supplier: state.admin.supplier,
    selectedCustomer: state.admin.customer
})

const mapDispatchToProps = (dispatch) => ({
    updateSupplierProfile: (id, data, status, token, success) => dispatch(update_supplier_profile(id, data, status, token, success)),
    udpateCustomerProfile: (id, data, status, token, success) => dispatch(update_customer_profile(id, data, status, token, success))
})

export default connect(mapStateToProps, mapDispatchToProps)(ProfileEdit)
